// The services must be imported here
import AddressesService from './addresses/AddressesService'
import MenusService from './menus/MenusService'

// The services must be declared here
export default {
    menus: MenusService,
    addresses: AddressesService
}
